import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import authService from "@/features/auth/services/authService";
import { useAuthStore } from "@/features/auth/stores/authStore";

/**
 * Sign-out mutation hook using TanStack Query
 * Handles sign-out logic. Auth store updates automatically via onAuthStateChanged listener.
 */
export function useSignOut() {
    const { clearAuth, setError } = useAuthStore();
    const navigate = useNavigate();

    const mutation = useMutation({
        mutationFn: async () => {
            await authService.signOut();
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to sign out. Please try again.";
            setError(errorMessage);
        },
        onSuccess: () => {
            clearAuth();
            navigate("/login");
        },
        // onAuthStateChanged will fire automatically when signOut succeeds
        // and the auth store will update automatically
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isLoading: mutation.isPending,
        signOut: mutation.mutate,
        signOutAsync: mutation.mutateAsync,
    };
}
